<div class="dialog-content">
    <h3 class="dialog-title">Cancelar Nota Fiscal de Consumidor</h3>

    <form [formGroup]="form" (ngSubmit)="cancelar()">
        <div class="form-group">
            <label for="justificativa" class="form-label">
                Justificativa do Cancelamento <span class="required">*</span>
            </label>
            <textarea
                id="justificativa"
                formControlName="justificativa"
                class="form-control"
                rows="4"
                placeholder="Digite a justificativa para o cancelamento (mínimo 15 caracteres)"
                [class.is-invalid]="form.get('justificativa')?.invalid && form.get('justificativa')?.touched">
            </textarea>
            <div class="invalid-feedback" *ngIf="form.get('justificativa')?.invalid && form.get('justificativa')?.touched">
                <div *ngIf="form.get('justificativa')?.errors?.['required']">
                    Justificativa é obrigatória
                </div>
                <div *ngIf="form.get('justificativa')?.errors?.['minlength']">
                    Justificativa deve ter pelo menos 15 caracteres
                </div>
            </div>
        </div>

        <div class="dialog-actions">
            <button
                type="button"
                class="btn btn-secondary"
                (click)="cancelarDialog()"
                [disabled]="loading">
                Cancelar
            </button>
            <button
                type="submit"
                class="btn btn-danger"
                [disabled]="form.invalid || loading">
                <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
                Confirmar Cancelamento
            </button>
        </div>
    </form>
</div>
